
const ko = require('knockout');

const $ = require('jquery');


ko.bindingHandlers.fioValue = {
	init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		console.warn(
			'`fioValue` binging is depricated, use `fio-input` component instead',
			element
		);

		const params = valueAccessor();

		// Observables for each name
		let lastName = ko.proxy(function () {
				return valueAccessor().lastName;
			}),
			firstName = ko.proxy(function () {
				return valueAccessor().firstName;
			}),
			middleName = ko.proxy(function () {
				return valueAccessor().middleName;
			});

		// Full name computed based on three separate names
		const fullName = ko.computed({
			read: function () {
				const last = $.trim(ko.unwrap(lastName) || '');
				const first = $.trim(ko.unwrap(firstName) || '');
				const middle = $.trim(ko.unwrap(middleName) || '');

				return last
					+ (first ? (' ' + first) : '')
					+ (middle ? (' ' + middle) : '');
			},
			write: function (full) {
				const words = $.grep(full.split(/\s+/g), function (x) {
					return Boolean(x);
				});
				lastName(words[0]);
				firstName(words[1]);
				middleName(words.slice(2).join(' '));
			},
		});

		const mode = ko.oneOf([ // Current mode of widget
			'simple', // One field mode (`.fio-all` under `.fio-simple`)
			'multiple', // Three fields mode (`.fio-{f,i,o}` under `.fio-multiple`)
		]);

		const activeName = ko.oneOf([ // Currently active part of name
			null, // none (e.g. when field is blured)
			'last', // editing last name
			'first', // edititng first name
			'middle', // edititng middle name
		]);

		let $element = $(element), // The wrapper
		// Two blocks for each of modes (should be children of element for selectVisibleChild to work)
			$fioSimple = $element.find('.fio-simple'),
			$fioMultiple = $element.find('.fio-multiple'),
		// combined input
			$fioFull = $element.find('.fio-all'),
		// separate inputs
			$fioLast = $element.find('.fio-f'),
			$fioFirst = $element.find('.fio-i'),
			$fioMiddle = $element.find('.fio-o'),
		// labels (may not be present in DOM)
			$fioLabelLast = $element.find('.fio-label-f'),
			$fioLabelFirst = $element.find('.fio-label-i'),
			$fioLabelMiddle = $element.find('.fio-label-o');

		const activeLabelClass = 'active'; // Class added to one of labels

		//#region Bind input values
		ko.applyBindingsToNode($fioFull[0], {
			value: fullName,
			valueUpdate: ['change', 'afterkeyup'],
		}, bindingContext);

		ko.applyBindingsToNode($fioLast[0], {
			value: lastName,
		}, bindingContext);

		ko.applyBindingsToNode($fioFirst[0], {
			value: firstName,
		}, bindingContext);

		ko.applyBindingsToNode($fioMiddle[0], {
			value: middleName,
		}, bindingContext);
		//#endregion

		// bind `.fio-simple` and `.fio-multiple` visibility to the `mode`
		ko.applyBindingsToNode(element, {
			selectVisibleChild: {
				observable: mode,
				animation: params.animation || 'fioReplaceBlocks',
				children: {
					simple: $fioSimple,
					multiple: $fioMultiple,
				},
			},
		}, bindingContext);

		// bind 'fioValue.mode' jQuery data to the `mode`
		ko.applyBindingsToNode(element, {
			jqData: {
				'fioValue.mode': mode,
			},
		}, bindingContext);

		// Watch for word count and switch to 'multiple' mode when necessary
		ko.computed(function () {
			const middle = $.trim(ko.unwrap(middleName) || '');
			const wordCount = (middle.match(/\s+/g) || []).length + 1;
			if (wordCount > 1) {
				mode('multiple');

				// Focus an input
				const $toBeFocused = ({
					last: $fioLast,
					first: $fioFirst,
					middle: $fioMiddle,
				}[activeName()]);
				if ($toBeFocused) {
					$toBeFocused.focus();
				}
			}
		}, null, { disposeWhenNodeIsRemoved: element });

		//#region Bind `activeLabelClass' class to the active label
		if ($fioLabelLast[0]) {
			ko.applyBindingsToNode($fioLabelLast[0], {
				css: ko.computed(function () {
					return 'last' == activeName() ? activeLabelClass : null;
				}),
			}, bindingContext);
		}

		if ($fioLabelFirst[0]) {
			ko.applyBindingsToNode($fioLabelFirst[0], {
				css: ko.computed(function () {
					return 'first' == activeName() ? activeLabelClass : null;
				}),
			}, bindingContext);
		}

		if ($fioLabelMiddle[0]) {
			ko.applyBindingsToNode($fioLabelMiddle[0], {
				css: ko.computed(function () {
					return 'middle' == activeName() ? activeLabelClass : null;
				}),
			}, bindingContext);
		}
		//#endregion

		//#region Update active label
		$fioFull.on('click keyup', function () {
			const value = $fioFull.val();
			let caret = $fioFull[0].selectionStart;
			if (null == caret) {
				caret = value.length;
			} // IE8
			const beforeCaret = value.slice(0, caret).replace(/\s+/g, ' ').replace(/^\s*/, '');
			const wordsBeforeCaret = beforeCaret.split(' ').length - 1;

			activeName(['last', 'first'][wordsBeforeCaret] || 'middle');
		});
		$fioFull.on('blur', function () {
			activeName(null);
		});
		//#endregion
	},
};
